// extracted by mini-css-extract-plugin
module.exports = {"alertModalCustom":"AlertModal_alertModalCustom__4Qv4A","alertModalFooterCustom":"AlertModal_alertModalFooterCustom__3NzIM"};